<mat-sidenav-container autosize class="sidenav-container">
  <mat-sidenav
    #sidenav
    mode="side"
    opened="true"
    position="start"
    hasBackdrop="true"
    autoFocus="false"
    [ngClass]="{
      'sidebar-collapsed': isSidebarCollapsed,
      'sidebar-expanded': !isSidebarCollapsed,
      'side-bar': !_auth.hasRoles,
    }"
  >
    <mat-nav-list>
      <div tabindex="0" class="sidebar-header" (click)="toggleSidebar()">
        <span class="material-symbols-outlined">
          @let isCollapsed =
            isSidebarCollapsed
              ? "assets/icon/collapse.svg"
              : "assets/icon/expand.svg";
          <img
            [ngSrc]="isCollapsed"
            alt="expand-collapse"
            height="24"
            width="24"
          />
        </span>
      </div>

      @for (menu of APP_MENUS; track menu; let i = $index) {
        @if (isSidebarCollapsed) {
          @if (menu.children?.length) {
            <mat-list-item
              [matMenuTriggerFor]="menuMenuRef"
              class="collapsed-menu-trigger"
              [ngClass]="{
                'active-link':
                  isChildRouteActive(menu) || activeDialogMenuIndex() === i,
              }"
              [appRolesPrivileges]="{
                type: 'HIDE',
                privilegeName: menu?.privilege ?? [],
              }"
            >
              <span class="material-symbols-outlined">{{ menu.icon }}</span>
            </mat-list-item>
            <mat-menu #menuMenuRef="matMenu" class="side-sub-nav">
              @for (child of menu.children; track child) {
                @if (
                  child.action === "kpiDashboard" ||
                  child.action === "configurePricingAdmin"
                ) {
                  <button
                    mat-menu-item
                    (click)="handleMenuAction(child.action, i)"
                    [routerLink]="child.link"
                    [appRolesPrivileges]="{
                      type: '',
                      privilegeName: [],
                      role: 'ADMIN',
                    }"
                  >
                    <div class="side-sub-item-list">
                      @if (child.icon) {
                        <span class="material-symbols-outlined">
                          {{ child.icon }}
                        </span>
                      }
                      <span>{{ child.label | translate }}</span>
                    </div>
                  </button>
                } @else {
                  <button
                    mat-menu-item
                    (click)="handleMenuAction(child.action, i)"
                    [routerLink]="child.link"
                  >
                    <div class="side-sub-item-list">
                      @if (child.icon) {
                        <span class="material-symbols-outlined">
                          {{ child.icon }}
                        </span>
                      }
                      <span>{{ child.label | translate }}</span>
                    </div>
                  </button>
                }
              }
            </mat-menu>
          } @else {
            <mat-list-item
              [routerLink]="menu.link"
              routerLinkActive="active-link"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="handleMenuClick(menu)"
              [ngClass]="{
                'active-link':
                  (menu.link === '/recipe/draft' &&
                    recipeDetailsSource() === 'draft') ||
                  (menu.link === '/recipe/final' &&
                    recipeDetailsSource() === 'final'),
              }"
              [appRolesPrivileges]="{
                type: 'HIDE',
                privilegeName: menu?.privilege ?? [],
              }"
            >
              <span class="material-symbols-outlined">{{ menu.icon }}</span>
            </mat-list-item>
          }
        }
        @if (!isSidebarCollapsed) {
          @if (menu.children?.length) {
            <mat-list-item
              (click)="toggleMenuExpansion(i)"
              class="expandable-list-item"
              [ngClass]="{
                'active-link':
                  isChildRouteActive(menu) || activeDialogMenuIndex() === i,
              }"
              [appRolesPrivileges]="{
                type: 'HIDE',
                privilegeName: menu?.privilege ?? [],
              }"
            >
              <div class="side-item-list">
                <span class="material-symbols-outlined">{{ menu.icon }}</span>
                <span>{{ menu.label | translate }}</span>
                <span class="spacer"></span>
                <span class="material-symbols-outlined">
                  {{ expandedMenus[i] ? "expand_less" : "expand_more" }}
                </span>
              </div>
            </mat-list-item>
            @if (expandedMenus[i]) {
              <div>
                @for (child of menu.children; track child) {
                  @if (
                    child.action === "kpiDashboard" ||
                    child.action === "configurePricingAdmin"
                  ) {
                    <mat-list-item
                      class="nested-option centered-list-item"
                      (click)="handleMenuAction(child.action, i)"
                      [routerLink]="child.link"
                      [appRolesPrivileges]="{
                        type: '',
                        privilegeName: [],
                        role: 'ADMIN',
                      }"
                    >
                      <div class="side-item-list">
                        @if (child.icon) {
                          <span class="material-symbols-outlined">
                            {{ child.icon }}
                          </span>
                        }
                        <span class="submenu-text">{{
                          child.label | translate
                        }}</span>
                      </div>
                    </mat-list-item>
                  } @else {
                    <mat-list-item
                      class="nested-option centered-list-item"
                      (click)="handleMenuAction(child.action, i)"
                      [routerLink]="child.link"
                    >
                      <div class="side-item-list">
                        @if (child.icon) {
                          <span class="material-symbols-outlined">
                            {{ child.icon }}
                          </span>
                        }
                        <span class="submenu-text">{{
                          child.label | translate
                        }}</span>
                      </div>
                    </mat-list-item>
                  }
                }
              </div>
            }
          } @else {
            <mat-list-item
              [routerLink]="menu.link"
              routerLinkActive="active-link"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="handleMenuClick(menu)"
              [ngClass]="{
                'active-link':
                  (menu.link === '/recipe/draft' &&
                    recipeDetailsSource() === 'draft') ||
                  (menu.link === '/recipe/final' &&
                    recipeDetailsSource() === 'final'),
              }"
              [appRolesPrivileges]="{
                type: 'HIDE',
                privilegeName: menu?.privilege ?? [],
              }"
            >
              <div class="side-item-list">
                <span class="material-symbols-outlined">{{ menu.icon }}</span>
                <span>{{ menu.label | translate }}</span>
              </div>
            </mat-list-item>
          }
        }
        @if (menu.isDevider) {
          <mat-divider />
        }
      }
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content
    class="sidenav-content flex"
    [class.collapsed]="isSidebarCollapsed"
    [class.no-padding]="removePadding()"
  >
    <router-outlet />
  </mat-sidenav-content>
</mat-sidenav-container>
